import React from 'react';
import { Button } from 'reactstrap';
export default function CustomViewButton(props){  
    const {keyvalue} = props;  
    return(
        <Button
            type="button"
            className='action-btn'
            color='success'
            id={`tooltip_view_key_${keyvalue}`}
            title="View"
            aria-label="View"
            {...props}
        >
            <span className='fas fa-eye'></span>
        </Button>
    );
}
